<template>
    <div class="btn-group" role="group">
        <button 
            type="button" 
            v-for="(button, index) in buttons" 
            :class="classes(button)" 
            :key="index"
            @click.prevent="onClick(button)">{{ button.label }}</button>
    </div>
</template>

<script>
export default {
    props: ['value', 'buttons', 'buttonClass'],
    methods: {
        classes: function(button) {
            let classes = {};
            let arr = ['btn', this.buttonClass].filter(el => el);
            
            if (this.value === button.value) {
                arr.push('btn-primary');
            } else {
                arr.push('btn-outline-primary');
            }

            arr.forEach(cls => {
                classes[cls] = true;
            });

            return classes;
        },
        onClick: function(button) {
            if (this.value == button.value) { // Unselect
                return this.$emit('input', null);
            }

            this.$emit('input', button.value);
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-outline-primary {
    background-color: transparent !important;
    color: var(--primary);
}
</style>